// Third party components
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// MUI components
import {Card, CardContent, Container, Grid, Typography} from '@mui/material';

// Storybook components
import { LineLoader, LoadingSpinner, SubHeader} from '@timmons-group/shared-react-components';

import PracticeDetails from '../features/Practice/PracticeDetails';

// Hooks
import { usePractice, ACTIONS } from '../hooks/usePractice';

const ViewPractice = () => {
  let { id } = useParams();
  const bigStore = usePractice();
  const { practiceState, unmount, dispatch } = bigStore;
  const { practice, modifying, loading } = practiceState;

  // This effect will also fire if the id changes in the url
  useEffect(() => {
    if(id) {
      dispatch({type: ACTIONS.SET_ID, payload: id});
    }

    // Unmount on cleanup to reset the state
    return () => {
      unmount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return (
      <Container>
        <Card>
          <CardContent>
            <LineLoader message="Loading..." color="secondary" />
          </CardContent>
        </Card>
      </Container>
    );
  }
  else if (!loading && (!practice || practiceState?.error)) {
    return (
      <Container>
        <Card>
          <CardContent>
            <Typography sx={{textAlign: 'center'}} variant="panelHeader">{practiceState?.error || 'Practice not found'}</Typography>
          </CardContent>
        </Card>
      </Container>
    );
  }

  return (
    <>
      <SubHeader
        title={ practice.practiceName }
        sx={{ fontSize: '1.25 rem'}}
      />
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <PracticeDetails practice={practice} />
        </Grid>
      </Grid>
      <LoadingSpinner isActive={modifying} />
    </>
  );
};

export default ViewPractice;
